import {
  Box,
  Button,
  Menu,
  MenuItem,
  ButtonGroup,
  Card,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Search as SearchIcon, Download as ExportIcon } from 'react-feather';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';
import CustomButton from 'src/components/common/customButton';

const MaternityResults = ({
  totalCount,
  onPaginationChange,
  exportFile,
  displayEmployees,
  allEmployees,
  activeBookings,
  activeTable,
  ...props
}) => {
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);
  const [exportType, setExportType] = useState('CSV');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [employees, setEmployees] = useState(
    displayEmployees.length > 0 &&
      displayEmployees.slice(page * limit, (page + 1) * limit)
  );
  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    if (activeTable == 1) {
      onPaginationChange('limit', event.target.value, activeTable);
    }
    if (activeTable == 0) {
      onPaginationChange('limit', event.target.value, activeTable);
    }
  };

  const fileList = [
    {
      id: 'CSV',
      title: 'csv'
    },
    {
      id: 'XLSX',
      title: 'xlsx'
    }
  ];

  const handleClose = (item) => {
    setAnchorEl(null);
    if (item) {
      setExportType(item.title);
    }
  };

  const setActiveTable = (value) => {
    setLimit(5);
    setPage(0);
    props.setActiveTable(value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (activeTable == 1) {
      onPaginationChange('page', newPage, activeTable);
    }
    if (activeTable == 0) {
      onPaginationChange('page', newPage, activeTable);
    }
  };
  
  return (
    <>
      <Grid container>
        <Grid xs={12} justifyContent="space-between" container item>
          <Grid
            item
            container
            sx={{
              borderRadius: 3,
              border: '1px solid #1778f2',
              width: '152px',
              height: '40px'
            }}
          >
            <CustomButton
              loading={
                props.loading.activeBookings || props.loading.allEmployees
              }
              onClick={() => setActiveTable(0)}
              fontSize={12}
              shadow="false"
              active={activeTable == 0}
              title="Maternity"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }}
            />
          </Grid>
          <Grid
            item
            container
            sx={{
              width: '180px'
            }}
          >
            <ButtonGroup
              variant="text"
              disabled={false}
              sx={{ boxShadow: '0 0 4px rgba(0,0,0,0.20)', borderRadius: 15 }}
            >
              <Button
                sx={{ px: 2 }}
                onClick={() => exportFile(exportType)}
                startIcon={<ExportIcon size="18" />}
              >
                Export
              </Button>
              <Button
                onClick={(e) => setAnchorEl(e.currentTarget)}
                endIcon={<ArrowDropDownIcon />}
              >
                {exportType}
              </Button>
            </ButtonGroup>
          </Grid>
          <Menu
            id="export-menu"
            open={open}
            anchorEl={anchorEl}
            onClose={() => handleClose()}
            MenuListProps={{
              'aria-labelledby': 'exporttypeMenu'
            }}
          >
            {fileList.map((menu) => (
              <MenuItem key={menu.id} onClick={() => handleClose(menu)}>
                {menu.title}
              </MenuItem>
            ))}
          </Menu>
        </Grid>
        <Grid xs item>
          <Card
            elevation={0}
            sx={{
              mt: 2
            }}
          >
            <PerfectScrollbar>
              <Box sx={{ minWidth: activeTable ? 1800 : 1000 }}>
                <TableContainer sx={{ maxHeight: 500 }}>
                  <Table
                    stickyHeader
                    aria-label="Employee list"
                    id="employee-list"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell padding="checkbox">
                          <Checkbox
                            sx={{
                              '& .MuiSvgIcon-root': {
                                fontSize: 18
                              }
                            }}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell>Employee ID</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Phone Number</TableCell>
                        <TableCell>Primary Month</TableCell>
                        <TableCell>Total</TableCell>
                        <TableCell>Attended</TableCell>
                        <TableCell>New Appointments</TableCell>
                        <TableCell>Cancelled</TableCell>
                        <TableCell>Customer Awaited</TableCell>
                        <TableCell>Confirmed By Ops</TableCell>
                        <TableCell>Rescheduled</TableCell>
                        <TableCell>Not Attended </TableCell>
                        <TableCell>Date of Registration</TableCell>
                        <TableCell>Trimester</TableCell>
                        <TableCell>Prog Start Date</TableCell>
                        <TableCell>Ideal End Date</TableCell>
                        <TableCell>Journey Status (Completed/Ongoing)</TableCell>
                        <TableCell>Specialities(Scheduled/Attended)</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(displayEmployees.length > 0
                        ? displayEmployees
                        : displayEmployees.slice(
                            page * limit,
                            (page + 1) * limit
                          )
                      ).map((employee, idx) => (
                        <TableRow hover key={idx}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              sx={{
                                '& .MuiSvgIcon-root': {
                                  fontSize: 18
                                }
                              }}
                              value="true"
                            />
                          </TableCell>
                          <TableCell>{employee.r_EmployeeId}</TableCell>
                          <TableCell>{employee.r_PatientName}</TableCell>
                          <TableCell>{employee.r_MobileNumber} </TableCell>
                          <TableCell>{employee.PrimaryMonth}</TableCell>
                          <TableCell>{employee.Total}</TableCell>
                          <TableCell>{employee.Attended}</TableCell>
                          <TableCell>{employee.NewAppt}</TableCell>
                          <TableCell>{employee.Cancelled}</TableCell>
                          <TableCell>{employee.Customer_Awaited}</TableCell>
                          <TableCell>{employee.Confirmed_by_ops}</TableCell>
                          <TableCell>{employee.Rescheduled}</TableCell>
                          <TableCell>{employee.Not_Attended}</TableCell>
                          <TableCell>{employee.Created_Date ? moment(employee.Created_Date).format('DD MMM YYYY'): "-"}</TableCell>
                          <TableCell>{employee.Trimester}</TableCell>
                          <TableCell>{employee.prog_start_date ? moment(employee.prog_start_date).format('DD MMM YYYY') : "-"}</TableCell>
                          <TableCell>{employee.prog_end_date ? moment(employee.prog_end_date).format('DD MMM YYYY') : "-"}</TableCell>
                          <TableCell>{employee.Journey_Status}</TableCell>
                          <TableCell>{employee.productName}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </PerfectScrollbar>
            <TablePagination
              component="div"
              count={totalCount}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default MaternityResults;
